// extracted by mini-css-extract-plugin
module.exports = {"header":"page_header__28swK"};